import { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { SUPPORT_ROUTINGS } from '../../define/global';
import ErrorPage from './ErrorPage';
import FormatRouter from './FormatRouter';

const initState = {
  INIT: 'init',
  COMPLETE: 'complete',
  FAIL: 'fail'
};

const ProductTypeRouter = ({ match, location }) => {
  const [state, setstate] = useState({ matchUrl: '', ok: initState.INIT });

  useEffect(() => {
    const matchUrl = `${match.path}/:format`;

    if (SUPPORT_ROUTINGS.findIndex((ele) => ele.producType === match.params.productType) !== -1){
      setstate({ matchUrl, ok: initState.COMPLETE });
    }else {
      setstate({ matchUrl, ok: initState.FAIL });
    }
  }, [match]);

  return (
    <>
      {state.ok === initState.COMPLETE && (
        <>
          <Route exact path={`${match.path}`}>
            <Redirect to={`${match.url}${match.url.endsWith('/') ? '' : '/'}hwp`} />
          </Route>
          <Route path={state.matchUrl} component={FormatRouter}></Route>
        </>
      )}
      {state.ok === initState.FAIL && (
        <ErrorPage msg={`${location.pathname} 는 존재하지 않습니다.`} />
      )}
    </>
  );
};

export default ProductTypeRouter;
